import Checkbox, { type CheckboxProps } from './Checkbox';

export type { CheckboxProps };
export default Checkbox;
